import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
/*istanbul ignore next */
function MultiSelectDropDown(props) {
  const customStyles = {
    control: (styles, { isDisabled }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#e9ecef;" : "#ffffff",
        border: isDisabled ? "0.5px solid transparent" : "0.5px solid #b8e7ff",
      };
    },
  };
  /*istanbul ignore next */
  const customMenuPosition = () => {
    return {
      top: 0,
    };
  };
  return (
    <div data-testid={props.id} style={{ width: "100%" }}>
      <Select
        className="multi-select-dropdown input-border"
        key={props.key}
        name={props.name}
        styles={customStyles}
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isMulti
        options={props.options}
        isDisabled={props.disabled}
        menuPosition={customMenuPosition}
        placeholder={props.placeholder}
        {...(props.onInputChange && { onInputChange: props.onInputChange })}
        {...(props.isLoading !== undefined && { isLoading: props.isLoading })}
        {...(props.filterOption && { filterOption: props.filterOption })}
        {...(props.onBlur && { onBlur: props.onBlur })}
      />
    </div>
  );
}

MultiSelectDropDown.propTypes = {
  id: PropTypes.string,
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onBlur: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    }),
  ),
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  isLoading: PropTypes.bool,
  filterOption: PropTypes.func,
};

MultiSelectDropDown.defaultProps = {
  id: "",
  key: undefined,
  name: "",
  value: [],
  onChange: () => {},
  onInputChange: undefined,
  onBlur: undefined,
  options: [],
  disabled: false,
  placeholder: "",
  isLoading: false,
  filterOption: undefined,
};

export default MultiSelectDropDown;
